import React, { Suspense, lazy } from "react";
import "./App.css";
import Header from "./components/Header/Header";
import Footer from "./components/Footer/Footer";
import { Routes, Route, Navigate } from "react-router-dom";
import "./i18n";
const Home = lazy(() => import("./pages/home/home.jsx"));
const Contact = lazy(() => import("./pages/contact/contact.jsx"));
const Products = lazy(() => import("./pages/products/products.jsx"));
const NotFound = lazy(() => import("./pages/notFound/notfound.jsx"));

export default function App() {
  return (
    <div className="app">
      <Header />
      <main className="app-content">
        <Suspense fallback={<div className="page-loader">Cargando…</div>}>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/products" element={<Products />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/404" element={<NotFound />} />
            
            <Route path="*" element={<Navigate to="/404" replace />} />
          </Routes>
        </Suspense>
      </main>
      <Footer />
    </div>
  );
}
